import BaseForm from '../base';
export class S2NodeForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
